// @flow

import AppDispatcher from 'PMT/flux/AppDispatcher';

import SessionStore from 'stores/SessionStore';

import PMTApiDashboard from 'PMT/api/ApiDashboard';

import ActionTypes from 'constants/ActionTypes';

import RestaurantDashboardInfo from 'PMT/entities/dashboard/RestaurantDashboardInfo';

import ApiError from 'PMT/entities/ApiError';

export default class DashboardAction {

  /**
   *
   */
  static loadRestaurantDashboardInfo() {
    PMTApiDashboard.getRestaurantDashboard(
      SessionStore.getRestaurantId(),
      DashboardAction.receiveRestaurantDashboardInfo,
      DashboardAction.receiveRestaurantDashboardInfoError
    );
  }

  static receiveRestaurantDashboardInfo(restaurantDashboardInfo: RestaurantDashboardInfo) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_RESTAURANT_DASHBOARD_RESPONSE_SUCCESS,
      restaurantDashboardInfo
    });
  }

  static receiveRestaurantDashboardInfoError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_RESTAURANT_DASHBOARD_RESPONSE_FAILURE,
      apiError
    });
  }

}



// WEBPACK FOOTER //
// ./scripts/actions/DashboardAction.js